// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2BnyC","list":"styles_list__1mZRr"};